module.exports = __webpack_public_path__ + "img/1696399133610-SH mirna yunia.jpg.effbc988.webp";